import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
Vue.use(vueCustomElement); 


import numberSpinner from './components/number-spinner.vue';
Vue.customElement('number-spinner',numberSpinner); 

import agePicker from './components/guest-picker.vue';
Vue.customElement('age-picker',agePicker); 

import searchCalendar from './components/search-calendar.vue';
Vue.customElement('search-calendar',searchCalendar);

import searchBox from './components/search-box.vue';
Vue.customElement('search-box',searchBox);


import experienceDropdown from './components/experience-dropdown.vue';
Vue.customElement('experience-dropdown', experienceDropdown);

import experienceDropdownElement from './components/experience-dropdown-element.vue';
Vue.customElement('experience-dropdown-element', experienceDropdownElement);

import experienceElementRequired from './components/experience-element-required.vue';
Vue.customElement('experience-element-required', experienceElementRequired);


import priceSpinner from './components/price-spinner.vue';
Vue.customElement('price-spinner', priceSpinner);

import cartContainer from './components/cart-container.vue';
Vue.customElement('cart-container', cartContainer);